import React, {
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useMemo,
  useState,
} from "react";
import {
  IInfoPlanDevice,
  IClientInfo,
} from "../../create/provider/create.provider.interface";
import { IPolicies } from "../../../../services/microservice/micelu/device/device-service.interface";

interface IProps {
  children: ReactNode;
}

interface IAuthAgent {
  email: string;
  password: string;
}

type IContext = {
  step: number;
  user: IAuthAgent | null;
  client: IClientInfo | null;
  infoPlanDevice: IInfoPlanDevice | null;
  infoPolicies: IPolicies[] | null;
  infoPayment: any;
  referenceTac: string;
  setInfoPayment: Dispatch<SetStateAction<any>>;
  setStep: Dispatch<SetStateAction<number>>;
  setUser: Dispatch<SetStateAction<IAuthAgent | null>>;
  setInfoPlanDevice: Dispatch<SetStateAction<IInfoPlanDevice | null>>;
  setReferenceTac: Dispatch<SetStateAction<string>>;
  setClient: Dispatch<SetStateAction<IClientInfo | null>>;
  setInfoPolicies: Dispatch<SetStateAction<IPolicies[] | null>>;
  handleInitialState: () => void;
};

export const CreateContext = React.createContext<IContext>({} as IContext);
export const useCreateContext = () => useContext<IContext>(CreateContext);

const CreateProvider = ({ children }: IProps) => {
  const [step, setStep] = useState<number>(1);
  const [user, setUser] = useState<IAuthAgent | null>(null);
  const [infoPlanDevice, setInfoPlanDevice] = useState<IInfoPlanDevice | null>(
    null,
  );
  const [infoPolicies, setInfoPolicies] = useState<IPolicies[] | null>(null);
  const [client, setClient] = useState<IClientInfo | null>(null);
  const [infoPayment, setInfoPayment] = useState<any>(null);
  const [referenceTac, setReferenceTac] = useState<string>("");
  const handleInitialState = () => {
    setStep(1);
    setUser(null);
    setInfoPlanDevice(null);
    setClient(null);
  };
  const context: IContext = useMemo(
    () => ({
      step,
      user,
      infoPlanDevice,
      client,
      infoPayment,
      infoPolicies,
      referenceTac,
      setStep,
      setUser,
      setInfoPlanDevice,
      setClient,
      handleInitialState,
      setInfoPayment,
      setInfoPolicies,
      setReferenceTac,
    }),
    [
      step,
      user,
      infoPlanDevice,
      client,
      infoPayment,
      infoPolicies,
      referenceTac,
    ],
  );
  return (
    <CreateContext.Provider value={context}>{children}</CreateContext.Provider>
  );
};

export default CreateProvider;
